import moment from 'moment';
import { format, parseISO, isValid } from 'date-fns';
import { ptBR, es } from 'date-fns/locale';
import { isBRServer } from '@/utils/Validators/validation';

const enhancedFormatDate = date => format(parseISO(date), 'dd/MM/yyyy');
const oldFormatDate = date => moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

export const formatHour = date => format(parseISO(date), 'HH:mm');
export const formatDate = (date, isEnabled) => (isEnabled ? enhancedFormatDate(date) : oldFormatDate(date));

export const formatDisplayDate = (value) => {
  if (!value) {
    return '';
  }

  let date;
  if (typeof value === 'string') {
    if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      date = new Date(`${value}T00:00:00`);
    } else {
      date = parseISO(value);
    }
  } else {
    date = new Date(value);
  }

  if (isValid(date)) {
    const locale = isBRServer ? ptBR : es;
    return format(date, "d 'de' MMM.", { locale });
  }

  return '';
};
